import { Routes, Route, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Navigate } from "react-router";
import { ApplicantProfileProfessionViewContainer } from "../components/applicant-profile-profession-view.container";
import { ApplicantProfileProfessionEditContainer } from "../components/applicant-profile-profession-edit.container";

export const ApplicantProfileProfession: React.FC = () => {
  const params = useParams();
  
  return (
    <div>
      <Helmet>
        <title>Applicant - Profession</title>
      </Helmet>
      <Routes>
        <Route index element={<Navigate to="view" replace />} />
        <Route path="view/*" element={<ApplicantProfileProfessionViewContainer applicantId={params.applicantId || ''}/>} />
        <Route path="edit/*" element={<ApplicantProfileProfessionEditContainer applicantId={params.applicantId || ''}/>} />
      </Routes>
    </div>
  );
};
